export const categories = [
  {
    id: 'mingxing-bagua',
    name: '明星八卦',
    slug: 'mingxing-bagua',
    description: '最新明星动态、恋情曝光、婚姻状况、私生活揭秘',
    icon: 'ri-star-line',
    color: 'accent',
  },
  {
    id: 'yingshi-zongyi',
    name: '影视综艺',
    slug: 'yingshi-zongyi',
    description: '热门影视剧透、综艺节目爆料、幕后花絮',
    icon: 'ri-film-line',
    color: 'primary',
  },
  {
    id: 'wanghong-baoliao',
    name: '网红爆料',
    slug: 'wanghong-baoliao',
    description: '网红圈内幕、主播八卦、社交媒体热点追踪',
    icon: 'ri-live-line',
    color: 'secondary',
  },
  {
    id: 'shehui-redian',
    name: '社会热点',
    slug: 'shehui-redian',
    description: '社会热议事件、话题追踪、全民关注焦点',
    icon: 'ri-fire-line',
    color: 'accent',
  },
  {
    id: 'dujia-mengliao',
    name: '独家猛料',
    slug: 'dujia-mengliao',
    description: '独家深度爆料、内幕消息、不为人知的真相',
    icon: 'ri-spy-line',
    color: 'primary',
  },
  {
    id: 'shishang-chaoliu',
    name: '时尚潮流',
    slug: 'shishang-chaoliu',
    description: '明星穿搭解析、红毯造型点评、时尚趋势解读',
    icon: 'ri-shirt-line',
    color: 'secondary',
  },
];

export type Category = typeof categories[number];